import { Navigate } from "react-router-dom";

import { useTournamentSlug } from "../../context/TournamentRouteContext";
import { tournamentPath } from "../../utility/tournamentUrls";

// Teams Overview is hidden during the BTA-38 rebrand (BTA-48).
// Team Edit at /teams/:teamId stays. Scoring still opens it.
const Teams = () => {
  const tournamentSlug = useTournamentSlug();
  return <Navigate to={tournamentPath(tournamentSlug, "/scoring")} replace />;
};

export default Teams;
